import React, { useCallback, useEffect, useState } from 'react';
import '../../../common/CommonStyle.scss';
import Dropdown from '../../../common/Dropdown/Dropdown';
import { useTranslation } from 'react-i18next';
import {
  defaultStyle,
  disabledStyle,
  errorStyle,
  warningStyle,
} from '../../../common/Select/SelectConfig';
import { getAuth } from '@/selectors/auth';
import { useSelector } from 'react-redux';
import { useMixedPlaceholder } from '@/hooks/useMixedPlaceholder';
import { VALIDATION_STATE_WARNING } from '@/utils/validationErrors';

const WriterComposer = ({
  index,
  item,
  errorBanner,
  validationState,
  handleChange,
  inputs,
  inputCustomClass,
  dropdownCustomClass,
  handleDeleteInput,
  handleAddInput,
  handleRoleChange,
  WriterComposerRole,
  readonly,
  disabled,
  mixedPlaceholder,
}: any) => {
  const [role, setRole] = useState();
  const { t } = useTranslation();
  const [onClickName, setOnClickName] = useState(false);
  const [onClickRole, setOnClickRole] = useState(false);
  const [onChangeName, setOnChangeName] = useState(false);
  const [onChangeRole, setOnChangeRole] = useState(false);

  useEffect(() => {
    setRole(WriterComposerRole.find((x: any) => x.value === item.role));
  }, [item.role, WriterComposerRole]);

  const { hasWriteAccess } = useSelector(getAuth);
  const validationClassName =
    validationState === VALIDATION_STATE_WARNING
      ? 'warning-input'
      : 'invalid-input';
  const validationDropdownStyle =
    validationState === VALIDATION_STATE_WARNING ? warningStyle : errorStyle;
  const nameError: boolean = onClickName && !onChangeName && !item.name;
  const roleError: boolean = onClickRole && !onChangeRole && !item.role;
  const checkDelete: boolean =
    inputs.length > 1 ||
    (inputs.length == 1 && inputs[0].role !== null && inputs[0].role !== '');
  const isMixedDisabled = () => {
    return readonly && (item?.role === 'Mixed' || item?.name === 'Mixed');
  };

  const getInputClassName = useCallback(() => {
    let className =
      !item.name && hasWriteAccess && !onChangeName && errorBanner
        ? `form-control ${validationClassName}`
        : 'form-control';
    if (inputCustomClass) {
      className += ` ${inputCustomClass}`;
    }
    return className;
  }, [
    item.name,
    hasWriteAccess,
    onChangeName,
    errorBanner,
    validationClassName,
    inputCustomClass,
  ]);

  const getDropdownClassName = useCallback(() => {
    return dropdownCustomClass
      ? `float-end ${dropdownCustomClass}`
      : 'float-end';
  }, [dropdownCustomClass]);

  const writerMixedPlaceholder = useMixedPlaceholder(mixedPlaceholder, {
    onBlur: () => {
      setOnClickName(false);
    },
    onClick: () => {
      setOnClickName(true);
    },
  });

  return (
    <>
      <div id={`writerComposer-${index}`} className="col-sm-12 list-item">
        <div className="pair-input contributor-input">
          <div className="float-start">
            <input
              type="text"
              className={getInputClassName()}
              id={`writerComposerName-${index}`}
              value={item.name}
              onChange={(e) => {
                setOnChangeName(true);
                handleChange(e, index, 'name');
              }}
              disabled={disabled}
              {...writerMixedPlaceholder}
            />
          </div>
          <div className={getDropdownClassName()}>
            <Dropdown
              id={`writerComposerRole-${index}`}
              placeholder={item.role === 'Mixed' ? t('track.mixed') : null}
              options={WriterComposerRole}
              selectedOption={item.role !== 'Mixed' ? role : ''}
              onOptionChange={(e: any) => {
                handleRoleChange(e, index);
                setOnChangeRole(true);
              }}
              isClearable={false}
              style={
                disabled
                  ? disabledStyle
                  : !item.role && !onChangeRole && errorBanner
                    ? validationDropdownStyle
                    : defaultStyle
              }
              onFocus={() => {
                setOnClickRole(true);
              }}
              onBlur={() => {
                setOnClickRole(false);
              }}
              disabled={disabled}
            ></Dropdown>
          </div>
        </div>
        {(checkDelete && !disabled) || isMixedDisabled() ? (
          <button
            className="icon-btn"
            onClick={() => handleDeleteInput(index)}
            type="button"
          >
            <i className="icon fas fa-times"></i>
          </button>
        ) : null}
      </div>
      {errorBanner && hasWriteAccess && (nameError || roleError) ? (
        <div
          className={
            validationState === VALIDATION_STATE_WARNING
              ? 'col-sm-3 popUp-container-warning'
              : 'col-sm-3 popUp-container'
          }
        >
          {nameError
            ? t('validationAlert.nameRequired.ErrorMessage')
            : roleError
              ? t('validationAlert.roleRequired.ErrorMessage')
              : null}
        </div>
      ) : null}
      {index === inputs.length - 1 &&
        (!disabled || isMixedDisabled() ? (
          <div className="col-sm-4 text-start">
            <button
              type="button"
              className="btn add-btn text-end"
              onClick={() => {
                handleAddInput();
              }}
              disabled={isMixedDisabled()}
            >
              <i className="icon fas fa-plus"></i>
              <span>{t('common.button.addWriterComposer')}</span>
            </button>
          </div>
        ) : null)}
    </>
  );
};
export default WriterComposer;
